export const PROJECTS_FOLDER = '/projects';
export const COMPRESSED_FOLDER = PROJECTS_FOLDER + '/compressed';
export const PLACEHOLDER_FOLDER = PROJECTS_FOLDER + '/placeholders';
export const RESUME_FOLDER = '/resume';
